module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_pwc_02.0189bd90.jpg";